import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-connected-app-redirect',
  templateUrl: './connected-app-redirect.component.html',
  styleUrls: ['./connected-app-redirect.component.scss']
})
export class ConnectedAppRedirectComponent implements OnInit {

  error: string = null;

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.error = null;
    this.activatedRoute.params.subscribe((pathParams) => {
      let appId: number = +pathParams['appId'];
      let authId: number = +pathParams['authId'];
      this.activatedRoute.queryParams.subscribe((queryParams) => {
        let code: string = queryParams['code'];
        let access_token: string = queryParams['access_token'];
        let expires_in: string = queryParams['expires_in'];
        let error: string = queryParams['error'];

        if (code) {
          localStorage.setItem('ecodocs_auth_' + authId, JSON.stringify({ code: code }));
          window.close();
        } else if (access_token) {
          localStorage.setItem('ecodocs_auth_' + authId, JSON.stringify({
            access_token: access_token,
            valid_before: new Date((new Date()).getTime() + (+expires_in) * 1000).toISOString()
          }));
          window.close();
        } else if (error) {
          this.error = error;
        }
      });
    });
  }

}
